import React from "react";
import { PulseLoader } from "react-spinners";
import { isAllBusiness } from "@/api";
import { SettingsUsersTable } from "./SettingsUsersTable";
import { UsersSettingsTab, UsersSettingsTabs } from "./tabs";
import { UserRowModel } from "./SettingsUsersTable";

type UserContentProps = {
  selectedTab: UsersSettingsTab;
  businessId?: string;
  users: UserRowModel[];
  inactiveFoodicsAccounts: UserRowModel[];
  usersQuery: { isPending: boolean };
  inactiveFoodicsAccountsQuery: { isPending: boolean };
};

export function UserContent({
  selectedTab,
  businessId,
  users,
  inactiveFoodicsAccounts,
  usersQuery,
  inactiveFoodicsAccountsQuery,
}: UserContentProps) {
  const LoadingContent = (
    <div className="flex justify-center items-center py-20">
      <PulseLoader color="lightgray" loading={true} size={15} speedMultiplier={0.6} />
    </div>
  );

  if (selectedTab === UsersSettingsTabs.inactive) {
    if (!businessId) {
      return null;
    }
    if (isAllBusiness(businessId)) {
      return (
        <div className="flex justify-center items-center bg-pureWhite h-[80%] w-full px-[19%]">
          <div className="font-medium text-feintGray text-center text-sm">
            Please choose a single business from the dropdown.
          </div>
        </div>
      );
    }
    if (inactiveFoodicsAccountsQuery.isPending) {
      return LoadingContent;
    }
    return inactiveFoodicsAccounts.length === 0 ? (
      <div className="flex justify-center items-center">
        <span>No Foodics accounts found</span>
      </div>
    ) : (
      <SettingsUsersTable
        key={businessId}
        accounts={inactiveFoodicsAccounts}
        selectedTab={selectedTab}
        businessId={businessId}
      />
    );
  }

  if (usersQuery.isPending) {
    return LoadingContent;
  }

  return users.length === 0 ? (
    <div className="flex justify-center items-center">
      <span>No BI accounts found</span>
    </div>
  ) : (
    <SettingsUsersTable accounts={users} selectedTab={selectedTab} businessId={businessId} />
  );
}
